export enum EJsonEntityType {
  KAction = 0,
  KDatasource = 1,
  KProject = 2,
  KScreenDesign = 3,
  KWorkFlow = 4,
  KApiManagement = 5,
  KNotificationTemplate = 6,
  KScheduledJobs = 7,
  KOfflineTable = 8,
  KNotificationLanguageTemplate = 9
}

export const ENTITY_TYPE_DISPLAY_NAMES: Record<number, string> = {
  [EJsonEntityType.KAction]: "Action",
  [EJsonEntityType.KDatasource]: "Datasource",
  [EJsonEntityType.KProject]: "Project",
  [EJsonEntityType.KScreenDesign]: "Screen Design",
  [EJsonEntityType.KWorkFlow]: "Workflow",
  [EJsonEntityType.KApiManagement]: "API Management",
  [EJsonEntityType.KNotificationTemplate]: "Notification Template",
  [EJsonEntityType.KScheduledJobs]: "Scheduled Jobs",
  [EJsonEntityType.KOfflineTable]: "Offline Table",
  [EJsonEntityType.KNotificationLanguageTemplate]: "Notification Language Template"
};
